import * as React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/index'
// hooks
import { useShowModal } from 'hooks/index'
// themes
import { colors } from 'themes/index'
// views
import {
  DragIcon,
  IconWrapper,
  OptionContent as Content,
  OptionWrapper as Wrapper
} from 'components/Modals/PropertyDetailsModal/components/Form/view'
import {
  EditIcon,
  TrashIcon,
  ButtonsWrapper
} from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// types
import { IFieldOption } from 'types/graphql'
// utils
import { darken } from 'polished'

const Button = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;

  &:hover {
    svg {
      path {
        fill: ${darken(0.1, colors.blue500)};
      }
    }
  }
`

interface IIncomingProps {
  isDisabled: boolean
  option: IFieldOption
  removeOption: () => void
}

const Option: React.FC<IIncomingProps> = ({ isDisabled, option, removeOption }) => {
  const { showModal } = useShowModal({ modalType: Modals.PICKLIST_OPTION_MODAL })

  const editOption = () => showModal({ option })

  return (
    <Wrapper isDisabled={isDisabled} data-testid='picklist-option' data-entity-id={option.id}>
      <Content isActive={option.active}>
        <IconWrapper>
          <DragIcon />
        </IconWrapper>
        <span>{option.label}</span>
      </Content>
      <Content isActive={option.active}>
        <span>{option.value}</span>
      </Content>

      <ButtonsWrapper>
        <Button onClick={editOption}>
          <EditIcon />
        </Button>
        <Button onClick={removeOption}>
          <TrashIcon />
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  )
}

export default Option
